import { SvgIcon, SvgIconProps } from '@mui/material'

export function CalenderIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.1665 6.3335C1.1665 6.05735 1.39036 5.8335 1.6665 5.8335H14.3332C14.6093 5.8335 14.8332 6.05735 14.8332 6.3335V13.3335C14.8332 13.9778 14.3108 14.5002 13.6665 14.5002H2.33317C1.68884 14.5002 1.1665 13.9778 1.1665 13.3335V6.3335ZM2.1665 6.8335V13.3335C2.1665 13.4255 2.24112 13.5002 2.33317 13.5002H13.6665C13.7586 13.5002 13.8332 13.4256 13.8332 13.3335V6.8335H2.1665Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33317 2.8335C2.24112 2.8335 2.1665 2.90812 2.1665 3.00016V5.8335H13.8332V3.00016C13.8332 2.90811 13.7586 2.8335 13.6665 2.8335H2.33317ZM1.1665 3.00016C1.1665 2.35583 1.68884 1.8335 2.33317 1.8335H13.6665C14.3109 1.8335 14.8332 2.35584 14.8332 3.00016V6.3335C14.8332 6.60964 14.6093 6.8335 14.3332 6.8335H1.6665C1.39036 6.8335 1.1665 6.60964 1.1665 6.3335V3.00016Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3335 0.833496C5.60964 0.833496 5.8335 1.05735 5.8335 1.3335V4.00016C5.8335 4.27631 5.60964 4.50016 5.3335 4.50016C5.05735 4.50016 4.8335 4.27631 4.8335 4.00016V1.3335C4.8335 1.05735 5.05735 0.833496 5.3335 0.833496Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6665 0.833496C10.9426 0.833496 11.1665 1.05735 11.1665 1.3335V4.00016C11.1665 4.27631 10.9426 4.50016 10.6665 4.50016C10.3904 4.50016 10.1665 4.27631 10.1665 4.00016V1.3335C10.1665 1.05735 10.3904 0.833496 10.6665 0.833496Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8335 11.3335C8.8335 11.0574 9.05735 10.8335 9.3335 10.8335H11.3335C11.6096 10.8335 11.8335 11.0574 11.8335 11.3335C11.8335 11.6096 11.6096 11.8335 11.3335 11.8335H9.3335C9.05735 11.8335 8.8335 11.6096 8.8335 11.3335Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1665 11.3335C4.1665 11.0574 4.39036 10.8335 4.6665 10.8335H6.6665C6.94265 10.8335 7.1665 11.0574 7.1665 11.3335C7.1665 11.6096 6.94265 11.8335 6.6665 11.8335H4.6665C4.39036 11.8335 4.1665 11.6096 4.1665 11.3335Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8335 8.6665C8.8335 8.39036 9.05735 8.1665 9.3335 8.1665H11.3335C11.6096 8.1665 11.8335 8.39036 11.8335 8.6665C11.8335 8.94265 11.6096 9.1665 11.3335 9.1665H9.3335C9.05735 9.1665 8.8335 8.94265 8.8335 8.6665Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1665 8.6665C4.1665 8.39036 4.39036 8.1665 4.6665 8.1665H6.6665C6.94265 8.1665 7.1665 8.39036 7.1665 8.6665C7.1665 8.94265 6.94265 9.1665 6.6665 9.1665H4.6665C4.39036 9.1665 4.1665 8.94265 4.1665 8.6665Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default CalenderIcon
